module.exports = __webpack_public_path__ + "static/media/tucked.64a9167b.svg";